import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Campaigns from "@/pages/Campaigns";
import CampaignEditor from "@/pages/CampaignEditor";
import Recipients from "@/pages/Recipients";
import Template from "@/pages/Template";
import SyncEvents from "@/pages/SyncEvents";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import StaffEngagement from "@/pages/StaffEngagement";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--rahi-bg)" }}>
      <div className="text-sm" style={{ color: "var(--rahi-soft)" }}>Loading…</div>
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading/>;
  if (!user) return <Navigate to="/login" replace/>;
  return <AppShell>{children}</AppShell>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loading/>;
  if (user) return <Navigate to="/campaigns" replace/>;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login/></PublicOnly>}/>
          <Route path="/campaigns" element={<Protected><Campaigns/></Protected>}/>
          <Route path="/campaigns/:id" element={<Protected><CampaignEditor/></Protected>}/>
          <Route path="/recipients" element={<Protected><Recipients/></Protected>}/>
          <Route path="/template" element={<Protected><Template/></Protected>}/>
          <Route path="/sync" element={<Protected><SyncEvents/></Protected>}/>
          <Route path="/settings" element={<Protected><Settings/></Protected>}/>
          <Route path="/reports" element={<Protected><Reports/></Protected>}/>
          <Route path="/staff-engagement" element={<Protected><StaffEngagement/></Protected>}/>
          <Route path="*" element={<Navigate to="/campaigns" replace/>}/>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
